import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
const selectedBadgeImgPath = 'assets/images/select_plan/selected_badge_gray.png';
export const NoticeSection = (props) => {
    return (React.createElement("div", { className: css(styles.container, props.classObject) },
        React.createElement("img", { className: css(styles.checkIcon), src: selectedBadgeImgPath, alt: "selected badge" }),
        props.children));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        backgroundColor: Colors.BackgroundLightBlueMagenta,
        padding: 16,
        fontSize: 14,
    },
    checkIcon: {
        width: 15,
        height: 15,
    },
});
